import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  mapProps,
  pure,
  withStateHandlers
} from 'recompose';
import { createSelector } from 'reselect';
import { withErrors } from 'recompose-extends';

import NewsTab from '../../views/News/NewsTab';
import { likeNews, favoriteNews } from '../../../actions';
import { selectNewsLike, selectNewsFavorite } from '../../../selectors';

export default compose(
  withErrors(),
  setDisplayName('NewsTabContainer'),
  connect(
    (state, { baseContentId }) =>
      createSelector(
        selectNewsLike(baseContentId),
        selectNewsFavorite(baseContentId),
        (like, favorite) => ({
          like,
          favorite
        })
      ),
    {
      onLike: likeNews,
      onFavorite: favoriteNews
    }
  ),
  mapProps(({ socialInfo, ...rest }) => ({
    ...socialInfo,
    ...rest
  })),
  withStateHandlers(
    { activeMobile: false, share: false },
    {
      onClickMobile: ({ activeMobile }) => () => ({
        activeMobile: !activeMobile
      }),
      onShare: ({ share }) => () => ({ share: !share })
    }
  ),
  pure
)(NewsTab);
